import { render, staticRenderFns } from "./principalDialog.vue?vue&type=template&id=73a9c4e2&scoped=true"
import script from "./principalDialog.vue?vue&type=script&lang=js"
export * from "./principalDialog.vue?vue&type=script&lang=js"
import style0 from "./principalDialog.vue?vue&type=style&index=0&id=73a9c4e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a9c4e2",
  null
  
)

export default component.exports